import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect } from 'react';
import CareNavigatorConstants from '../core-utils/messages/CareNavigatorConstants';
import {
  BlankCard,
  StarRating,
  TestimonialCard,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  getRatingColor,
  getRatingText,
} from '../core-utils/helper-utils/helper';
import { reportProps } from './StopLossAggregateTable';
const CareNavigationFeedback: React.FC<reportProps> = ({ data }) => {
  const messages = CareNavigatorConstants.QUARTERLY_REPORT;

  const useStyles = makeStyles()({
    container: {
      marginTop: '20px',
      gap: '20px',
    },
    innerContainer: {
      width: '22.5%',
      display: 'flex',
      flexDirection: 'column',
    },
  });
  const { classes } = useStyles();

  const getDesignation = (role: string) => {
    switch (role) {
      case 'care_navigator_pharmacist':
        return 'Pharmacist';
      case 'care_navigator_nurse':
        return 'Nurse';
      case 'care_navigator_customer_service':
        return 'Customer Service';
      default:
        return 'Unknown';
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <Grid container className={classes.container}>
        <Grid className={classes.innerContainer}>
          <BlankCard
            mainGridStyles={{
              padding: '20px 10px',
              borderBottomLeftRadius: '0px',
              borderBottomRightRadius: '0px',
            }}
            body={
              <Grid
                container
                style={{ gap: '10px' }}
                sx={{
                  flexDirection: 'column',
                }}
              >
                <Typography
                  fontSize="20px"
                  fontType="medium"
                  lineHeight="35.2px"
                  textColor={getRatingColor(
                    data?.careNavigationFeedback?.avgRating,
                  )}
                >
                  {getRatingText(data?.careNavigationFeedback?.avgRating)}
                </Typography>
                <StarRating
                  value={data?.careNavigationFeedback?.avgRating?.toFixed(1)}
                  size="large"
                  showRating={
                    <Typography
                      fontSize="22px"
                      lineHeight="38px"
                      fontType="medium"
                      textColor={getRatingColor(
                        data?.careNavigationFeedback?.avgRating,
                      )}
                    >
                      {data?.careNavigationFeedback?.avgRating?.toFixed(1)}
                    </Typography>
                  }
                  precision={0.5}
                  readOnly={true}
                  color={getRatingColor(
                    data?.careNavigationFeedback?.avgRating,
                  )}
                />
                <Typography
                  fontSize="14px"
                  fontType="regular"
                  lineHeight="22.4px"
                  textColor={patientAccessTheme.palette.text.lowemphasis}
                >
                  {`(${messages.overAllRating} ${data?.careNavigationFeedback?.totalCount} Members)`}
                </Typography>
              </Grid>
            }
          />
          <BlankCard
            mainGridStyles={{
              padding: '30px 10px',
              borderTopLeftRadius: '0px',
              borderTopRightRadius: '0px',
            }}
            body={
              <Grid
                container
                style={{ gap: '45px' }}
                sx={{
                  flexDirection: 'column',
                }}
              >
                {[
                  { value: 1, label: 'Poor', color: '#D46A6D' },
                  { value: 2, label: 'Fair', color: '#F2763D' },
                  {
                    value: 3,
                    label: 'Good',
                    color: patientAccessTheme.palette.warning.A600,
                  },
                  {
                    value: 4,
                    label: 'Very Good',
                    color: patientAccessTheme.palette.progressBar?.background4,
                  },
                  { value: 5, label: 'Excellent', color: '#17A39C' },
                ].map(({ value, label, color }) => (
                  <StarRating
                    key={value}
                    value={value}
                    maxStarCount={value}
                    size="large"
                    precision={0.5}
                    readOnly
                    color={color}
                    showRating={
                      <Grid
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '7px',
                          alignItems: 'center',
                        }}
                      >
                        <Typography
                          fontSize="17px"
                          lineHeight="27px"
                          fontType="regular"
                          textColor={
                            patientAccessTheme.palette.text.lowemphasis
                          }
                        >
                          {data?.careNavigationFeedback?.ratingData[value]}
                        </Typography>
                        <Typography
                          fontSize="17px"
                          lineHeight="27px"
                          fontType="bold"
                          textColor={color}
                        >
                          {label}
                        </Typography>
                      </Grid>
                    }
                  />
                ))}
              </Grid>
            }
          />
        </Grid>
        <Grid container style={{ width: '75%' }}>
          {data?.careNavigationFeedback?.data?.length > 0 &&
            data?.careNavigationFeedback?.data?.map((item: any) => (
              <Grid style={{ height: '50%', width: '50%' }}>
                <TestimonialCard
                  backgroundBubbleStyles={{ width: '210px' }}
                  name={item?.careNavName}
                  designation={getDesignation(item?.careNavRole)}
                  review={item?.review}
                  rating={item?.rating}
                />
              </Grid>
            ))}
        </Grid>
      </Grid>
    </>
  );
};
export default CareNavigationFeedback;
